import type { ConsumerRTHGraphTheme } from '../../components/web-only/consumerRTHGraph'
import { colors, fonts } from '../dwa-base'

const consumerRTHGraphTheme: ConsumerRTHGraphTheme = {
  Container: [
    {
      style: {
        position: 'relative',
        pointerEvents: 'none',
        paddingBottom: '1em',
      },
    },
  ],
  Body: [
    {
      style: {
        margin: '10px',
        padding: '10px',
        backgroundColor: String(colors.consumerRTH.chartBackground),
      },
    },
  ],
  BodyWithWatermark: [
    {
      style: {
        margin: '10px',
        padding: '10px',
        backgroundColor: String(colors.consumerRTH.paneBackground),
      },
    },
  ],
  Plot: [
    {
      style: {
        display: 'inline-block',
        pointerEvents: 'none',
        filter: 'inherit',
      },
    },
  ],
  PlotWithWatermark: [
    {
      style: {
        display: 'inline-block',
        pointerEvents: 'none',
        filter: 'blur(3px)',
      },
    },
  ],
  NoData: [
    {
      style: {
        position: 'absolute',
        top: '40%',
        left: '25%',
        opacity: '0.8',
        zIndex: '1',
        textAlign: 'center',
        lineHeight: '1.5',
      },
    },
  ],
  NoDataText: [
    {
      style: {
        fontFamily: String(fonts.defaultMedium),
        fontSize: '30px',
        color: String(colors.consumerRTH.primaryText),
      },
    },
  ],
  NoDataSubText: [
    {
      style: {
        fontFamily: String(fonts.defaultLight),
        fontSize: '20px',
        color: String(colors.consumerRTH.primaryText),
      },
    },
  ],
}

export default consumerRTHGraphTheme
